import { faArrowAltCircleUp } from "@fortawesome/free-solid-svg-icons/faArrowAltCircleUp";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons/faCirclePlus";
import { faClipboard } from "@fortawesome/free-solid-svg-icons/faClipboard";
import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dialog, DialogActions, DialogContent, Slide } from "@mui/material";
import { PaperArrastavel } from "../../dialog-arrastavel/PaperArrastavel";
import { ListaSistemaTintometrico } from "app/api/classes/ProdutoApi";
import Legenda from "app/components/itens-orcamento/legenda/Legenda";
import { IProduto } from "app/types/produto/IProduto";
import useDropdownEncaixarNaTela from "app/hooks/useDropdownEncaixarNaTela";
import clsx from "clsx";
import globalMU from "globalMU";
import React, { useContext, useState } from "react";
import { IColuna } from "../../../types/IColuna";
import { BarraPesquisa } from "../../itens-orcamento/barra-pesquisa-incluir-item/BarraPesquisa";
import { Paginacao } from "../../itens-orcamento/paginacao/Paginacao";
import { GridItensPesquisaProdutos } from "../../pesquisa-produtos/grid-itens/GridItensPesquisaProdutos";
import {
  Disponibilidade,
  MaisFiltros,
  MaisFiltrosDados
} from "../../pesquisa-produtos/mais-filtros/MaisFiltros";
import {
  DadosPesquisaProduto,
  PesquisaProduto
} from "../../pesquisa-produtos/pesquisa-produto/PesquisaProdutos";
import { BarraFerramentasGridPesquisaProdutos } from "../grid-itens/barra-ferramentas-grid/BarraFerramentasGridPesquisaProdutos";
import { TabelaProdutosSelecionados } from "../grid-itens/barra-ferramentas-grid/TabelaProdutosSelecionados";
import {
  ProdutoRepetido
} from "../grid-itens/TBody/ItemPesquisaProduto";
import { PesquisaProdutoPagina, ProdutosSelecionadosContext } from "../PaginaPesquisaProdutoContainer";

const estilosPaginaPesquisaProduto = require("./paginaPesquisaProduto.module.scss").default;
const estilosBarraFerramentasGrid = require("../grid-itens/barra-ferramentas-grid/barra-ferramentas-grid.module.scss").default;
const estilosBotoes = require("../../../estilos/botoes.module.scss").default;

export type PaginaPesquisaProdutoProps = {
  chamadoPeloTrocarProduto?: boolean // 470882
  ocultarBarraPesquisa?: boolean
  permiteProdutoForaEstoque?: boolean;
  mostrarBotaoPesquisarInserirContinuar: boolean;
  mostrarBotaoProdutosForaDeEstoque: boolean;
  onPesquisarInserirContinuar: (pesquisa: PesquisaProdutoPagina) => void;
  onPesquisarProdutosForaEstoque: () => void;
  exibirBarraGrid: boolean;
  myRef: React.MutableRefObject<undefined>
};

export type PaginaPesquisaProdutoContextType = {
  pesquisandoApenasParaFiltroProdutosLupa?: boolean; // 470698
  pesquisandoNoOrcamentoVenda: boolean;
  onPesquisaPreVenda: () => void;
  onPesquisasAnteriores: () => void;
  onPesquisarCores: () => void;

  pesquisaProduto: DadosPesquisaProduto;
  markupProdutoOrcamento: boolean;
  exibirCampoFiltroEstoqueDisponivel: boolean;
  exibirMensagemParametroEstoqueOutrasFiliais: boolean;
  exibirCampoPesquisaEstoqueOutrasFiliais: boolean;
  exibirColunaEstoqueTotalProdutoVendas: boolean;
  filtrouAlgumCheckboxEstoquesDisponivel: boolean; //43588
  parametroControleLote: boolean //43588
  mascara: string;
  onPesquisaClasse: () => void;
  onExcluirClasse: () => void;
  onPesquisaFornecedor: () => void;
  onExcluirFornecedor: () => void;
  onCodigoModificado: (codigo: string) => void;
  onReferenciaModificado: (referncia: string) => void;
  onDescricaoModificado: (descricao: string) => void;
  onClasseModificado: (classe: string) => void;
  onFornecedorModificado: (fornecedor: string) => void;
  onEstoqueDisponivelFilialCorrente: (estoqueDisponivel: boolean) => void;
  //onEstoqueDisponivelFiliais: (estoqueDisponivelFiliais: boolean) => void;
  onEstoqueDisponivelOutrasFiliais: (estoqueDisponivelOutrasFilial: boolean) => void;
  onEstoqueDisponivelCD: (estoqueDisponivelCD: boolean) => void; // 435588
  onOrdemModificado: (ordem: string) => void;
  onMarkupInicialModificado: (markupInicial: string) => void;
  onMarkupFinalModificado: (markupFinal: string) => void;

  opcoesDisponibilidade: Disponibilidade[];
  opcoesSistemaTintometrico: ListaSistemaTintometrico[];
  utilizaSistemaTintometrico: boolean;
  produtoEmTransito: boolean;
  maisFiltrosDados: MaisFiltrosDados;
  onCodigoFabricanteModificado: (codigoFabricante: string) => void;
  onCodigoSistemaTintometricoModificado: (
    sistemaTintometricoOid: number
  ) => void;
  onTextoTecnicoModificada: (textoTecnico: string) => void;
  onModeloModificado: (modelo: string) => void;
  onDisponibilidadesModificadas: (disponibilidadesOid: string[]) => void;
  onProdutoEmTransitoModificado: (
    ProdutoEmTransito: boolean
  ) => void;
  onApenasProdutoFinalModificado: (apenasProdutoFinal: string) => void;
  onApenasFabricacaoPropriaModificado: (apenasFabricacaoPropria: boolean) => void //
  onProdutoOfertaModificado: (apenasProdutoOferta: boolean) => void;
  onConsiderarEstoqueDisponivelLote: (considerarEstoqueDisponivelLote: boolean) => void //435588
  onTipoFiltroEstoqueModificado: (tipoFiltroEstoque: string) => void //435588
  onQuantidadeInicialFiltroEstoqueModificado: (quantidade: number) => void; // 435588
  onQuantidadeFinalFiltroEstoqueModificado: (quantidade: number) => void; // 435588
  onToggleSelecionarTodasColunas: (selecionar: boolean) => void;
  onToggleColunaSelecionada: (nomeColuna: string, selecionada: boolean) => void;
  colunas: IColuna[];
  itens: IProduto[];
  onAlterarFonte: (tamanho: number) => void;
  tamanhoFontePadrao: number;
  corSelecionado: string;
  textoSelecionado: string;
  onMostrarInformacoesProduto: (item: IProduto) => void;
  onMostrarImagens: (identificadorItem: string, classeElementoAncora: string) => void;
  tintasConfiguradas: { [codigo: string]: string };
  onMostrarTinta: (item: IProduto) => void;
  onProdutoRepetido: (produtoRepetido: ProdutoRepetido) => void;
  onPesquisaProdutoAgregado: (item: IProduto) => void;
  onProdutoAgregadoExpandido: (item: IProduto) => void;
  onProdutosSelecionados: (item: IProduto[]) => void;
  mascaraClasse: string;
  onAlteracaoQuantidade: (
    produtoSelecionado: IProduto,
    quantidade: number
  ) => void;
  exibirTextoTecnico: boolean;
  exibirColunaMarkup: boolean;
  exibirEstoqueOutrasFiliais: boolean;
  exibirEstoqueTotal: boolean;
  utilizaDescontoMaximoBonificacaoAvancados: boolean;
  exibirPrecoAVista?: boolean
  chamadoParaInserirProdutoNoOrcamento: boolean;
  processandoProduto: boolean

  onPesquisarPaginaPesquisaProduto: () => void;

  desativarBotaoComparar: boolean;
  desativarBotaoAcoes: boolean;
  onOk: (item?: IProduto) => void;
  onInserirContinuar: () => void;
  onSelecionarTodos: () => void;
  onInserirNovo: () => void;
  onIncrementarQuantidade: () => void;
  onComparar: () => void;
  numeroTotalPaginas: number;
  onAlterarListaSelecionada: (numeroIndexPagina: number) => void;
  obterPermiteEngrenagemGrid: boolean;
  produtosSelecionados: IProduto[];
  onToggleProdutoSelecionado: (item: IProduto) => void;
  produtosAgregadoExpandido: { [key: number]: boolean };
  produtosAgregadoSugeridoExpandido: { [key: number]: boolean };
  iconeProdutoAgregadoSugeridoExpandido: boolean;
  iconeProdutoAgregadoExpandido: boolean;
  exibirLocalFisico: boolean
  habiliarAcoesGrid: boolean
  desabilitarPesquisarHistorico: boolean
  numeroCasasDecimaisQuantidade: number
  //orcamentoSomenteLeitura: boolean
  numeroPagina: number
  autoFocusReferencia: boolean
  inputAutofocusRef: React.MutableRefObject<any>
  ocultarSubPaginas?: boolean
  modalCestaProdutosAberto: boolean
  onFecharModalCestaProdutos: () => void
};

export const PaginaPesquisaProdutoContext = React.createContext<PaginaPesquisaProdutoContextType>({
  pesquisandoNoOrcamentoVenda: false,
  onPesquisaPreVenda: () => { },
  onPesquisasAnteriores: () => { },
  onPesquisarCores: () => { },
  pesquisaProduto: {} as DadosPesquisaProduto,
  markupProdutoOrcamento: false,
  exibirCampoFiltroEstoqueDisponivel: false,
  exibirMensagemParametroEstoqueOutrasFiliais: false,
  exibirCampoPesquisaEstoqueOutrasFiliais: false,
  exibirColunaEstoqueTotalProdutoVendas: false,
  filtrouAlgumCheckboxEstoquesDisponivel: false,
  parametroControleLote: false,
  mascara: "",
  onPesquisaClasse: () => { },
  onExcluirClasse: () => { },
  onPesquisaFornecedor: () => { },
  onExcluirFornecedor: () => { },
  onCodigoModificado: () => { },
  onReferenciaModificado: () => { },
  onDescricaoModificado: () => { },
  onClasseModificado: () => { },
  onFornecedorModificado: () => { },
  onEstoqueDisponivelFilialCorrente: () => { },
  onEstoqueDisponivelOutrasFiliais: () => { },
  onEstoqueDisponivelCD: () => { },
  onOrdemModificado: () => { },
  onMarkupInicialModificado: () => { },
  onMarkupFinalModificado: () => { },
  opcoesDisponibilidade: [],
  opcoesSistemaTintometrico: [],
  utilizaSistemaTintometrico: false,
  produtoEmTransito: false,
  maisFiltrosDados: {} as MaisFiltrosDados,
  onCodigoFabricanteModificado: () => { },
  onCodigoSistemaTintometricoModificado: () => { },
  onTextoTecnicoModificada: () => { },
  onModeloModificado: () => { },
  onDisponibilidadesModificadas: () => { },
  onProdutoEmTransitoModificado: () => { },
  onApenasProdutoFinalModificado: () => { },
  onApenasFabricacaoPropriaModificado: () => { },
  onProdutoOfertaModificado: () => { },
  onConsiderarEstoqueDisponivelLote: () => { },
  onTipoFiltroEstoqueModificado: () => { },
  onQuantidadeInicialFiltroEstoqueModificado: () => { },
  onQuantidadeFinalFiltroEstoqueModificado: () => { },
  onToggleSelecionarTodasColunas: () => { },
  onToggleColunaSelecionada: () => { },
  colunas: [],
  itens: [],
  onAlterarFonte: () => { },
  tamanhoFontePadrao: 0,
  corSelecionado: "",
  textoSelecionado: "",
  onMostrarInformacoesProduto: () => { },
  onMostrarImagens: () => { },
  tintasConfiguradas: {},
  onMostrarTinta: () => { },
  onProdutoRepetido: () => { },
  onPesquisaProdutoAgregado: () => { },
  onProdutoAgregadoExpandido: () => { },
  onProdutosSelecionados: () => { },
  mascaraClasse: "",
  onAlteracaoQuantidade: () => { },
  exibirTextoTecnico: false,
  exibirColunaMarkup: false,
  exibirEstoqueOutrasFiliais: false,
  exibirEstoqueTotal: false,
  utilizaDescontoMaximoBonificacaoAvancados: false,
  chamadoParaInserirProdutoNoOrcamento: false,
  processandoProduto: false,
  onPesquisarPaginaPesquisaProduto: () => { },
  desativarBotaoComparar: false,
  desativarBotaoAcoes: false,
  onOk: () => { },
  onInserirContinuar: () => { },
  onSelecionarTodos: () => { },
  onInserirNovo: () => { },
  onIncrementarQuantidade: () => { },
  onComparar: () => { },
  numeroTotalPaginas: 0,
  onAlterarListaSelecionada: () => { },
  obterPermiteEngrenagemGrid: false,
  produtosSelecionados: [],
  onToggleProdutoSelecionado: () => { },
  produtosAgregadoExpandido: {},
  produtosAgregadoSugeridoExpandido: {},
  iconeProdutoAgregadoSugeridoExpandido: false,
  iconeProdutoAgregadoExpandido: false,
  exibirLocalFisico: false,
  habiliarAcoesGrid: false,
  desabilitarPesquisarHistorico: false,
  numeroCasasDecimaisQuantidade: 3,
  //orcamentoSomenteLeitura: false,
  numeroPagina: 0,
  autoFocusReferencia: false,
  inputAutofocusRef: { current: undefined },
  modalCestaProdutosAberto: false,
  onFecharModalCestaProdutos: () => { },
})

export const PaginaPesquisaProduto = (props: PaginaPesquisaProdutoProps) => {
  const contexto = useContext(PaginaPesquisaProdutoContext)
  const {
    produtosSelecionados: produtosNaCesta,
    onAplicarItens,
    desativarBotaoAplicarItens,
    processandoProduto: processandoProdutoCesta,
    produtoJaExisteNoOrcamento,
    onAlterarAcaoProdutoRepetido,
    onLimparProdutosSelecionados,
  } = useContext(ProdutosSelecionadosContext)
  const [dropDownAcoesAberto, setDropDownAcoesAberto] = useState(false)
  const { menuRef: menuAcoesCestaRef, abrirParaCima: dropDownAcoesAbrirParaCima, abrirParaEsquerda: dropDownAcoesAbrirParaEsquerda } =
    useDropdownEncaixarNaTela<HTMLUListElement>(dropDownAcoesAberto)
  {/* atenção

          a pesquisa de produtos é usado em varios locais no sistema
          incluise em filtros para selecao multipla de produtos dentro e fora do orcamento

         */}

  const desativarBotaoAcoesProdutosSelecionados = !(produtosNaCesta ?? []).some((produto) => produtoJaExisteNoOrcamento(produto));

  const onInserirNovoProdutosSelecionados = () => {
    (produtosNaCesta ?? []).filter((produto) => produtoJaExisteNoOrcamento(produto)).forEach((produto) => onAlterarAcaoProdutoRepetido(produto, 0));
    setDropDownAcoesAberto(false);
  };

  const onIncrementarQuantidadeProdutosSelecionados = () => {
    (produtosNaCesta ?? []).filter((produto) => produtoJaExisteNoOrcamento(produto)).forEach((produto) => onAlterarAcaoProdutoRepetido(produto, 1));
    setDropDownAcoesAberto(false);
  };

  const BarraGrid = (sufixoId: string) => (
    <>
      {props.exibirBarraGrid && (
        <>
          <br />
          <BarraFerramentasGridPesquisaProdutos
            key={`PaginaPesquisaProduto_BarraFerramentasGrid${sufixoId}`}
            sufixoId={sufixoId}
          />
        </>
      )}
    </>
  );

  const PaginacaoComponent = (
    <>
      {contexto.numeroTotalPaginas > 1 && (
        <Paginacao
          paginaAtual={contexto.numeroPagina}
          totalPaginas={contexto.numeroTotalPaginas}
          onAlterarListaSelecionada={contexto.onAlterarListaSelecionada}
          desabilitarPaginacao={contexto.processandoProduto}
          key="PaginaPesquisaProduto_Paginacao"
          id="PaginaPesquisaProduto_Paginacao"
        />
      )}
    </>
  );

  const BarraPesquisaComponent = (!props.ocultarBarraPesquisa &&
    <div>
      <BarraPesquisa
        pesquisandoNoOrcamentoVenda={contexto.pesquisandoNoOrcamentoVenda}
        desabilitarPesquisarHistorico={contexto.desabilitarPesquisarHistorico}
        onPesquisaPreVenda={contexto.onPesquisaPreVenda}
        onPesquisasAnteriores={contexto.onPesquisasAnteriores}
        onPesquisarCores={contexto.onPesquisarCores}
        key="PaginaPesquisaProduto_BarraPesquisa"
      />
    </div>
  );

  const BotoesPesquisa = (
    <div
      className={
        estilosPaginaPesquisaProduto.submitContainerPaginaPesquisaProduto
      }
    >
      <button
        onClick={() => {
          contexto.onPesquisarPaginaPesquisaProduto();
        }}
        id="PaginaPesquisaProduto_botaoPesquisar"
        key="PaginaPesquisaProduto_botaoPesquisar"
        disabled={contexto.processandoProduto}
      >
        Pesquisar
      </button>
      {props.mostrarBotaoPesquisarInserirContinuar && (
        <button
          title="Se a pesquisa retornar apenas 1 produto, ele será automaticamente inserido no orçamento e após inserir, voltará para a tela de pesquisa&#013;Caso produto já exista no orçamento, será inserido novamente."
          id="PaginaPesquisaProduto_botaoPesquisarInserirContinuar"
          key="PaginaPesquisaProduto_botaoPesquisarInserirContinuar"
          disabled={contexto.processandoProduto}
          onClick={() => {
            props.onPesquisarInserirContinuar({
              ...contexto.pesquisaProduto,
              ...contexto.maisFiltrosDados,
            });
          }}
        >
          Pesquisar, Inserir e Continuar
        </button>
      )}
      {props.mostrarBotaoProdutosForaDeEstoque && (
        <button onClick={() => props.onPesquisarProdutosForaEstoque()}
          id="PaginaPesquisaProduto_botaoProdutosForaDeEstoque"
          key="PaginaPesquisaProduto_botaoProdutosForaDeEstoque"
          title="Veja parâmetro: Faz venda com produto fora do Estoque"
          disabled={contexto.processandoProduto || !props.permiteProdutoForaEstoque}>
          Produtos Fora de Estoque
        </button>
      )}
    </div>
  );


  return (
    <div>
      {/* atenção

          a pesquisa de produtos é usado em varios locais no sistema
          incluise em filtros para selecao multipla de produtos

          a "BarraPesquisaComponent" não deve ser mostrado em todos os casos
         */}
      {BarraPesquisaComponent}

      <div
        id="PaginaPesquisaProduto_PesquisaProdutoDiv"
      >
        <PesquisaProduto 
          key="PaginaPesquisaProduto_PesquisaProduto" 
        />
        <MaisFiltros />
        <br ref={props.myRef} />
        {BotoesPesquisa}

        {contexto.chamadoParaInserirProdutoNoOrcamento && ( // 491123
          <Dialog
            id="PaginaPesquisaProduto_DialogCestaProdutos"
            maxWidth="xl"
            open={contexto.modalCestaProdutosAberto && (produtosNaCesta ?? []).length > 0}
            onClose={contexto.onFecharModalCestaProdutos}
            PaperComponent={PaperArrastavel}
            // 491123 — Paper ocupa quase a tela inteira (95vw/95vh): "crescer" a partir de um
            // canto pequeno (Grow) faz um retângulo desse tamanho parecer esticado/distorcido.
            // Slide de baixo para cima é o padrão do próprio Material Design para dialogs em tela
            // cheia, e combina melhor com o botão flutuante ficando fixo perto do rodapé.
            //
            // Migração MUI v4 -> v9: `PaperProps`/`TransitionComponent`/`TransitionProps` saíram
            // em favor da dupla `slots` (qual componente) + `slotProps` (props dele).
            slots={{ transition: Slide }}
            slotProps={{
              paper: { style: { maxWidth: "95vw", maxHeight: "95vh" } },
              transition: { direction: "up", timeout: 300 } as any,
            }}
          >
            <div className="_px-4 _pt-4 _pb-2 _border-b-4 _border-[#f4f4f4]"
              id="PaginaPesquisaProduto_DialogCestaProdutos_div"
              data-arrastar-dialog
            >
              <div className="_flex _justify-between _items-center">
              <h4 className="_font-bold"
                id="PaginaPesquisaProduto_DialogCestaProdutos_H4"
              >
                Cesta de Produtos
              </h4>
              <div className="_flex _flex-row _items-center _gap-x-3"
                id="PaginaPesquisaProduto_DialogCestaProdutos_div2"
              >
                <button
                  className={clsx(estilosPaginaPesquisaProduto.botaoContornoCestaProdutos, "no-global-button")}
                  disabled={processandoProdutoCesta}
                  onClick={onLimparProdutosSelecionados}
                  id="PaginaPesquisaProduto_DialogCestaProdutos_BotaoRemoverTodos"
                  title="Remove todos os produtos da cesta"
                >
                  <i
                    className={clsx(
                      "material-symbols-rounded",
                      estilosBotoes.iconeMaterialAcao,
                      processandoProdutoCesta && estilosBotoes.desabilitado
                    )}
                    style={{ fontSize: "20px" }}
                  >delete_forever</i>
                  <span className={estilosBarraFerramentasGrid.textoBotao}>Remover Todos</span>
                </button>
                <div className="_relative"
                  id="PaginaPesquisaProduto_DialogCestaProdutos_div3"
                >
                  <button
                    className={clsx(estilosPaginaPesquisaProduto.botaoContornoCestaProdutos, "no-global-button")}
                    disabled={desativarBotaoAcoesProdutosSelecionados || processandoProdutoCesta}
                    onClick={() => setDropDownAcoesAberto(!dropDownAcoesAberto)}
                    id="paginaPesquisaProduto_DialogCestaProdutos_botaoAcoes"
                    title="Ações"
                  >
                    <FontAwesomeIcon icon={faClipboard} />
                    <span className={estilosBarraFerramentasGrid.textoBotao}>Ações</span>
                  </button>
                  {dropDownAcoesAberto && (
                    <ul
                      ref={menuAcoesCestaRef}
                      className={clsx(
                        "_absolute _right-0 _bg-white _z-20",
                        estilosPaginaPesquisaProduto.dropdownCresceDoBotao,
                        dropDownAcoesAbrirParaCima && estilosPaginaPesquisaProduto.dropdownAbrirParaCima,
                        dropDownAcoesAbrirParaEsquerda && estilosPaginaPesquisaProduto.dropdownAbrirParaEsquerda
                      )}
                      id="PaginaPesquisaProduto_DialogCestaProdutos_ACOES"
                      onMouseLeave={() => setDropDownAcoesAberto(false)}
                    >
                      <li
                        className={clsx(estilosBotoes.botaoIcone, estilosBarraFerramentasGrid.sombraBotao)}
                        onClick={onInserirNovoProdutosSelecionados}
                        style={{ cursor: "pointer" }}
                        id="PaginaPesquisaProduto_DialogCestaProdutos_InserirNovo"
                      >
                        <FontAwesomeIcon  
                          icon={faCirclePlus}
                          color="#409fff"
                          title="Inserir Novo"
                          id="PaginaPesquisaProduto_DialogCestaProdutos_InserirNovoIcone"
                        />
                        <span>Inserir Novo</span>
                      </li>
                      <li
                        className={clsx(estilosBotoes.botaoIcone, estilosBarraFerramentasGrid.sombraBotao)}
                        onClick={onIncrementarQuantidadeProdutosSelecionados}
                        style={{ cursor: "pointer" }}
                        title="Incrementar Quantidade"
                        id="PaginaPesquisaProduto_DialogCestaProdutos_Incrementar"
                      >
                        <FontAwesomeIcon
                          icon={faArrowAltCircleUp}
                          color="#409fff"
                          id="PaginaPesquisaProduto_DialogCestaProdutos_IncrementarIcone"
                        />
                        <span>Incrementar Quantidade</span>
                      </li>
                    </ul>
                  )}
                </div>
                <a
                  id="PaginaPesquisaProduto_DialogCestaProdutos_BotaoFechar"
                  className={estilosPaginaPesquisaProduto.botaoFecharCestaProdutos}
                  style={{ cursor: "pointer" }}
                  tabIndex={0}
                  onClick={contexto.onFecharModalCestaProdutos}
                >
                  <FontAwesomeIcon icon={faTimes}
                    id="PaginaPesquisaProduto_DialogCestaProdutos_BotaoFecharIcone"
                  />
                </a>
              </div>
              </div>
              <p className={estilosPaginaPesquisaProduto.subtituloCestaProdutos}
                id="PaginaPesquisaProduto_DialogCestaProdutos_Subtitulo"
              >
                Confira os produtos selecionados e ajuste as quantidades necessárias. Os itens selecionados só serão inseridos para o orçamento de venda após a sua confirmação.
              </p>
            </div>
            <DialogContent
              id="PaginaPesquisaProduto_DialogCestaProdutos_DialogContent"
            >
              <TabelaProdutosSelecionados />
            </DialogContent>
            {(produtosNaCesta ?? []).length > 0 && (
              <DialogActions
                className={clsx("_flex _justify-between _items-center", estilosPaginaPesquisaProduto.rodapeCestaProdutos)}
                id="PaginaPesquisaProduto_DialogCestaProdutos_DialogActions"
              >
                <span
                  className={estilosPaginaPesquisaProduto.totalItensCestaProdutos}
                  id="PaginaPesquisaProduto_DialogCestaProdutos_TotalItens"
                >
                  TOTAL: {produtosNaCesta.length} {produtosNaCesta.length == 1 ? "ITEM" : "ITENS"}
                </span>
                <button
                  className={clsx(estilosPaginaPesquisaProduto.botaoInserirNoOrcamento, "no-global-button")}
                  id="TabelaProdutosSelecionados_botaoAplicarItens"
                  disabled={processandoProdutoCesta || desativarBotaoAplicarItens}
                  onClick={async () => {
                    // onAplicarItens (via onAdicionarItensGrid) já cuida de blockScreen/unblockScreen
                    // com a mensagem — bloquear aqui de novo sem mensagem sobrescrevia o overlay antes
                    // do navegador sequer pintar o texto (a segunda chamada é síncrona, antes do 1º await)
                    const quantidadeProdutosAplicados = produtosNaCesta.length
                    const sucesso = await onAplicarItens()
                    // Se houve mensagem de erro/aviso (ex: tinta sem cor) ou falha ao gravar, onAdicionarItensGrid
                    // já mostrou a mensagem correspondente — o modal deve continuar aberto para o usuário corrigir
                    if (!sucesso) return
                    contexto.onFecharModalCestaProdutos()
                    globalMU.showInfoMessage(
                      quantidadeProdutosAplicados == 1
                        ? "1 produto foi adicionado ao orçamento."
                        : `${quantidadeProdutosAplicados} produtos foram adicionados ao orçamento.`
                    )
                  }}
                >
                  <i className="material-symbols-rounded" style={{ fontSize: "18px" }}>check_circle</i>
                  <span id="TabelaProdutosSelecionados_botaoAplicarItens_Texto">Inserir no orçamento</span>
                </button>
              </DialogActions>
            )}
          </Dialog>
        )}
        {contexto.itens?.length > 0 && (
          <div className={estilosPaginaPesquisaProduto.separadorGridProdutos} >

            {BarraGrid("_Topo")}

            <GridItensPesquisaProdutos key="PaginaPesquisaProduto_GridItensPesquisaProdutos" />
            {PaginacaoComponent}

            {BarraGrid("_Rodape")}
          </div>
        )}

        <br />
        {contexto.itens?.length > 0 && <div
          className={`_grid _grid-rows-1 ${estilosPaginaPesquisaProduto.containerLengendaPaginaPesquisaProduto}`}
        >
          <Legenda
            key="PaginaPesquisaProduto_Legenda"
            itens={[
              {
                nome: "Produto em Oferta",
                cor: "var(--mu-azul-marcador, #0000FF)",
              },
              {
                nome: "Sob Encomenda",
                cor: "#EC780F",
              },
              {
                nome: "Fora de Linha",
                cor: "#00C800",
              },
              {
                nome: "Fora do Mix",
                cor: "#800000",
              },
              {
                nome: "Estoque Indisponível",
                cor: "#FF0000",
              },
              {
                nome: "Saldão",
                cor: "#AB2DE1",
              },
            ]}
          />
        </div>
        }
        {<section style={{ marginBottom: "100px" }} />}
      </div>

    </div>
  );

  {/* atenção

          a pesquisa de produtos é usado em varios locais no sistema
          incluise em filtros para selecao multipla de produtos dentro e fora do orcamento

         */}


};
